import React, {useContext, useState, useEffect} from "react";
import Button from '@material-ui/core/Button';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {InvitesContext} from "../context/InvitesContext";

const canAllowNext = (activeStep, invite, phoneConfirmationStepIsValid) => {
    console.log(`canAllowNext ${activeStep} ${invite}`);
    switch (activeStep) {
        case 0:
            // !! is the check for non empty
            return !!invite.selectedInvite;
        case 1:
            return !!invite.eventTitle && !!invite.eventDescription;
        case 2:
            return !!invite.locationName && !!invite.locationAddress && !!invite.eventStartDateTime;
        case 3:
            return (!invite.churchName && !invite.churchAddress) ||
                (!!invite.churchName && !!invite.churchAddress && !!invite.churchStartTime);
        case 4:
            return (phoneConfirmationStepIsValid);
        default:
            return true;
    }
}

export default function ActionsContainer(props) {
    const {activeStep, handlePrev, handleNext, classes, phoneConfirmationStepIsValid} = props;
    const invitesContext = useContext(InvitesContext);
    const [allowNext, setAllowNext] = useState(false);

    useEffect(() => {
        setAllowNext(canAllowNext(activeStep, invitesContext.state.invite, phoneConfirmationStepIsValid));
    }, [activeStep, invitesContext.state.invite, phoneConfirmationStepIsValid]);

    return (
        <div className={classes.actionsContainer}>
            {activeStep > 0 ?
                <Button
                    variant="contained"
                    onClick={handlePrev}
                    className={classes.prevButton}
                    color="secondary"
                >
                    <ChevronLeftIcon/>
                    ÎNAPOI
                </Button> : ''
            }
            {activeStep < 5 ?
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.nextButton}
                    disabled={!allowNext}
                >
                    CONTINUĂ <ChevronRightIcon/>
                </Button> : ''
            }
        </div>
    )
}